module.exports = "<fuse-main></fuse-main>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main